/* eslint-disable */
import { DashboardTileCategory } from '../dto/dashboard-tile-category';
import { DashboardTileInternationalizationContent } from '../dto/dashboard-tile-internationalization-content';
import { Priority } from '../dto/priority';

export interface DashboardTileDetailDto {
  id: number;
  internalName: string;
  fileName?: string | null;
  requiredProductShorthands: string[];
  dashboardTileCategory?: DashboardTileCategory | null;
  validFromDate: Date;
  expireDate?: Date | null;
  priority: Priority;
  isWarning: boolean;
  showOnDashboard: boolean;
  showInApi: boolean;
  contentPerLanguage: DashboardTileInternationalizationContent[];
}

export const fixDashboardTileDetailDtoFromJson = (dto?: DashboardTileDetailDto | null): void => {
  if (!dto) {
    return;
  }
  dto.validFromDate = dto.validFromDate && new Date(dto.validFromDate);
  dto.expireDate = dto.expireDate && new Date(dto.expireDate);
};

export const fixDashboardTileDetailDtoToJson = (dto?: DashboardTileDetailDto | null): void => {
  if (!dto) {
    return;
  }
};
